import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { COLOR_TEXT, COLOR_TEXT_INVERSE, COLOR_CAMPAIGN_GOOD_PRIMARY, COLOR_CAMPAIGN_BETTER_SECONDARY, COLOR_CAMPAIGN_BLACK_WEEK, COLOR_CAMPAIGN_HAPPY_WEEKEND, COLOR_CAMPAIGN_BEST_PRIMARY } from '../../tokens/js/variables.default.js';

// @ts-nocheck
var VARIANT_BACKGROUND = {
  yellow: COLOR_CAMPAIGN_GOOD_PRIMARY,
  green: COLOR_CAMPAIGN_BETTER_SECONDARY,
  black: COLOR_CAMPAIGN_BLACK_WEEK,
  orange: COLOR_CAMPAIGN_HAPPY_WEEKEND,
  red: COLOR_CAMPAIGN_BEST_PRIMARY,
  "default": COLOR_CAMPAIGN_HAPPY_WEEKEND
};
var bgByVariant = function bgByVariant() {
  var _VARIANT_BACKGROUND$$;
  var $variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  return (_VARIANT_BACKGROUND$$ = VARIANT_BACKGROUND[$variant]) !== null && _VARIANT_BACKGROUND$$ !== void 0 ? _VARIANT_BACKGROUND$$ : VARIANT_BACKGROUND["default"];
};
var promotionBackground = css(["background-color:", ";"], function (_ref) {
  var $variant = _ref.$variant;
  return bgByVariant($variant);
});
var PromotionBadge = styled.div.withConfig({
  displayName: "PromotionBadgestyle__PromotionBadge",
  componentId: "sc-1xat1ay-0"
})(["display:inline-flex;align-items:center;gap:10px;picture{width:auto;}img{", " ", "}"], mq.sMax(css(["height:", ";"], function (props) {
  return props.$mobileSize ? "".concat(props.$mobileSize, "px") : '40px';
})), mq.s(css(["height:", ";"], function (props) {
  return props.$desktopSize ? "".concat(props.$desktopSize, "px") : '40px';
})));
var PromotionTag = styled.div.withConfig({
  displayName: "PromotionBadgestyle__PromotionTag",
  componentId: "sc-1xat1ay-1"
})(["border-radius:8px;width:", ";padding:8px 16px;line-height:0px;display:flex;justify-content:center;align-items:center;gap:12px;", ";.PromotionIcon{fill:", ";}"], function (_ref2) {
  var $fullWidthBg = _ref2.$fullWidthBg;
  return $fullWidthBg ? '100%' : 'auto';
}, promotionBackground, function (_ref3) {
  var $variant = _ref3.$variant;
  if ($variant === 'yellow' || $variant === 'orange') {
    return COLOR_TEXT;
  }
  return COLOR_TEXT_INVERSE;
});
var PromotionPill = styled.span.withConfig({
  displayName: "PromotionBadgestyle__PromotionPill",
  componentId: "sc-1xat1ay-2"
})(["width:1.2rem;height:0.6rem;border-radius:0.3rem;flex:0 0 auto;", ";"], promotionBackground);
var PromotionLabel = styled.span.withConfig({
  displayName: "PromotionBadgestyle__PromotionLabel",
  componentId: "sc-1xat1ay-3"
})(["font:var( ", " );font-weight:", ";width:100%;color:", ";"], function (_ref4) {
  var $smallText = _ref4.$smallText;
  return $smallText ? '--font-body-s' : '--font-headline-xs';
}, function (_ref5) {
  var $smallText = _ref5.$smallText;
  return $smallText ? 'bold' : '';
}, function (_ref6) {
  var $fullWidthBg = _ref6.$fullWidthBg,
    $variant = _ref6.$variant;
  if (!$fullWidthBg) {
    return COLOR_TEXT;
  }
  if ($variant === 'yellow' || $variant === 'orange') {
    return COLOR_TEXT;
  }
  return COLOR_TEXT_INVERSE;
});

export { PromotionBadge, PromotionLabel, PromotionPill, PromotionTag, VARIANT_BACKGROUND, bgByVariant };
//# sourceMappingURL=PromotionBadge.style.js.map
